Greenmile.Survey.Sidebar.EntityGridPreview = function (question) {

    var projection = JSON.parse(question.entityProjection);
    var restriction = JSON.parse(question.entityRestriction);
    var criteria = restriction.criteriaChain[0].and[0] || {};

    var gridContainerSelector = '#Survey .newQuestionContent .answerContent .gridPreviewContainer[question_id="' + question.id + '"]';
    var entityToActionGrid = question.entity.key || question.entity.description || question.entity.name;
    var customNamespace = 'SurveyQuestionEntityPreview';

    this.getData = function (grid, gridOptions, updated) {
      var CollectionConstructor = App.Collections[entityToActionGrid + 's'];

      var reOrder = function(data) {
        return data;
      };
      if (criteria.attr !== 'id') {
        projection.maxResults = 5;
      } else {
        reOrder = function(data) {
          var list = data.models.reduce(function(json, item){
            var attributes = item.attributes;
            json[attributes.id] = attributes;
            return json;
          }, {});
          const uniqueIds = [...new Set(criteria.in)];
          const models = uniqueIds.map(id => list[id]);
          return new CollectionConstructor(models);
        };
      }

      var collection = new CollectionConstructor();
      if (question.entityRestriction) {
          restriction = JSON.parse(question.entityRestriction);
          criteria = restriction.criteriaChain[0].and[0] || {};

          collection.filterWithRestrictions({
              filter: restriction,
              criteria: JSON.stringify(projection),
              success: function (question, data) {
                this.addItems(reOrder(data), grid, gridOptions, updated);
              }.bind(this, question)
          });

      }
    };

    this.addItems = function (collection, grid, gridOptions, updated) {
      Monet.Grid.addDataToGridWithOptionsNoPagination(customNamespace, grid.getColumns(), collection, gridOptions);

      if (criteria.attr === 'id' && !updated) {
        var columns = [];
        columns.push({
          id: "#",
          name: "#",
          width: 40,
          behavior: "selectAndMove",
          selectable: false,
          resizable: false,
          cssClass: "cell-reorder dnd cell-row",
          formatter: function(row, cell, value, column, dataContext) {
            return '<div class="dragQuestionDomain"></div>';
          }
        });
        grid.getColumns().forEach(function (col) {
          columns.push(col);
        });
        grid.setColumns(columns);
      }
      Greenmile.Survey.Sidebar.EntityGridPreviewDnD(grid, collection, question);

      grid.invalidateAllRows();
      grid.resizeCanvas();
    };

    this.createGrid = function () {
        var columns,
            dataView,
            grid,
            layout;

        App.Forms[entityToActionGrid] = App.Forms[entityToActionGrid] || {};
        if (!App.Forms[entityToActionGrid].fields) {
            delete App.Forms[entityToActionGrid].dataMapper;
            var dm = new Monet.Builder.DataMapper();
            dm.setEntity(entityToActionGrid);
            dm.build(this.createGrid.bind(this));

        } else {

            layout = Greenmile.Utils.createGridLayoutFromProjection.parse(entityToActionGrid, question.entityProjection);

            var options = {
                entity: customNamespace,
                columnCheckBox: {
                    show: false,
                    options: {
                        checkOnClickRow: false
                    }
                },
                columnEdit: {
                    show: false
                },
                actions: [],
                entityToActionGrid: entityToActionGrid,
                gridContainner: gridContainerSelector,
                multiColumnSort: true,
                multiSelect: false,
                sortBy: 'client',

                selectable: false,
                editable: true,
                enableCellNavigation: true,
                forceFitColumns: true,
                autoEdit: false,
                autoHeight:true
            };

            columns = Monet.Grid.getGridLayout(layout, 'SurveyQuestionEntity');
            dataView = new Monet.Grid.DataProvider(columns, null, customNamespace);
            grid = new Monet.Grid.GenericGrid(gridContainerSelector, dataView, columns, options);

            this.table = grid;
            this.dataView = dataView;

            var gridOptions = {
                grid: grid,
                dataView: dataView
            };
            this.getData(grid, gridOptions);
        }

    };

};
